// 如果小于5条数据就显示actionPicker，否则显示Picker
import { picker } from "@/shared/utils/picker";
import { actionPicker } from "@/packages/action-picker";
import { OptionItem } from "@/model/OptionItem";

export const openCommonPicker = (config: {
  title: string;
  options: OptionItem[];
  index?: number;
  valueKey?: string;
  onConfirm: (value: OptionItem) => void;
}): void => {
  if (config.options.length <= 5) {
    actionPicker.open({
      title: config.title,
      valueKey: config.valueKey || "name",
      columns: config.options,
      onConfirm: config.onConfirm,
      cancelText: "取消",
    });
  } else {
    picker.open({
      columns: config.options,
      valueKey: config.valueKey || "name",
      index: config.index,
      title: config.title,
      onConfirm: config.onConfirm,
    });
  }
};
